import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import './validate'
import './sentry'

//import 'firebaseui/dist/firebaseui.css'
//import '@mdi/font/css/materialdesignicons.min.css';

Vue.config.productionTip = false

if(process.env.NODE_ENV !== 'development'){
  console.log = () => {void(0)}
  console.trace = () => {void(0)}
  console.table = () => {void(0)}
} 

console.trace = () => {void(0)}

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')

